import { createContext, useContext, type Context } from 'react';

/**
 * The width the containing preview panel is currently rendered at, published by `PreviewPanel` to
 * its content. `PreviewPanel` sources it from the persisted width (via the suspended
 * `usePreviewPanelWidth`) on first paint and from the live width after a resize, so it always
 * matches the actual panel column width.
 *
 * Panel content (e.g. the issue view) reads this for its compact/wide layout decision instead of the
 * preview-panels provider context width. That provider width is seeded once at mount and races store
 * population under streaming SSR, defaulting to the compact width — which made the issue view render
 * compact and then flip to wide (MAGMA-5474). Published and consumed only behind
 * `jfp-magma-fix-streaming-nin-issue-preview-panel`.
 */
export const PreviewPanelWidthContext: Context<number | undefined> = createContext<
	number | undefined
>(undefined);

export const useContainingPreviewPanelWidth = (): number | undefined =>
	useContext(PreviewPanelWidthContext);
